import { create } from 'zustand';

const useDemocracyModeStore = create((set) => ({
    mode: null,
    version: null,
    hasActiveSession: null,
    campCode: null,
    loaded: false,

    setInfo: (info) => set({
        mode: info.mode || null,
        version: info.version || null,
        hasActiveSession: info.hasActiveSession ?? null,
        campCode: info.campCode || null,
        loaded: true,
    }),

    reset: () => set({
        mode: null,
        version: null,
        hasActiveSession: null,
        campCode: null,
        loaded: false,
    }),
}));

export default useDemocracyModeStore;
